import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { apiPlugin } from "./router/api";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/css/main.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@mdi/font/css/materialdesignicons.css";

window.addEventListener("message", (event) => {
  if (event.data === "login-expirado") {
    router.push({ name: "login" });
  }
});
const pinia = createPinia();
const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VTextField: {
      variant: "outlined",
    },
    VSelect: {
      variant: "outlined",
    },
    VTextarea: {
      variant: "outlined",
    },
    VAutocomplete: {
      variant: "outlined",
    },
    icons: {
      defaultSet: "mdi",
    },
  },
});
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(apiPlugin);
app.mount("#app");
